export default "__VITE_ASSET__N9LsDGtP__"